"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getExtrasRunsTypeShort = (type) => {
    switch (type) {
        case 1:
            return '*nb';
        case 2:
            return '*wd';
        case 3:
            return '*b';
        case 4:
            return '*lb';
        case 5:
            return 'nb+*b';
        case 6:
            return 'nb+*lb';
    }
};
const getOverSummary = (props) => {
    if (!props.runsBatField)
        props.runsBatField = 'runs_bat';
    if (!props.runsExtraField)
        props.runsExtraField = 'runs_extra';
    if (!props.runsExtrasTypeField)
        props.runsExtrasTypeField = 'extras_type';
    if (!props.wicketField)
        props.wicketField = 'dismissed_batter_id';
    let output = '';
    lodash_1.each(props.over, (ball) => {
        if (ball.wicket || ball[props.wicketField] !== undefined) {
            output += 'W';
        }
        else if (ball[props.runsBatField] + ball[props.runsExtraField] > 0) {
            if (ball[props.runsExtraField] === 0) {
                output += ball[props.runsBatField];
            }
            else if (ball[props.runsBatField] === 0) {
                if (ball[props.runsExtrasTypeField] === 5 || ball[props.runsExtrasTypeField] === 6) {
                    output += getExtrasRunsTypeShort(ball[props.runsExtrasTypeField]).replace('*', (ball[props.runsExtraField] - 1).toString());
                }
                else {
                    output += getExtrasRunsTypeShort(ball[props.runsExtrasTypeField]).replace('*', ball[props.runsExtraField] === 1 ? '' : ball[props.runsExtraField]);
                }
            }
            else {
                output +=
                    getExtrasRunsTypeShort(ball[props.runsExtrasTypeField]).replace('*', ball[props.runsExtraField] === 1 ? '' : ball[props.runsExtraField]) +
                        '+' +
                        ball[props.runsBatField];
            }
        }
        else {
            output += props.simplified ? '.' : '•';
        }
        output += props.spaced ? '   ' : ' ';
    });
    return props.simplified && output === '' ? ' ' : lodash_1.trim(output);
};
exports.default = getOverSummary;
//# sourceMappingURL=getOverSummary.js.map